import z from 'zod'

export const PAGE_SIZES = [10, 20, 30, 40, 50]

export const DEFAULT_PAGE_SIZE = 20

export const paginationSchema = z
  .object({
    pageIndex: z.number().optional().default(0),
    pageSize: z.number().optional().default(DEFAULT_PAGE_SIZE),
  })
  .default({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })

export const cursorPaginationSchema = z
  .object({
    cursor: z.string().optional(),
    pageSize: z.number().optional().default(DEFAULT_PAGE_SIZE),
  })
  .default({
    cursor: undefined,
    pageSize: DEFAULT_PAGE_SIZE,
  })

export const sortingSchema = <T extends string[] | readonly string[]>(
  sortColumns: T,
) =>
  z
    .array(
      z.object({
        id: z.enum(sortColumns),
        desc: z.boolean(),
      }),
    )
    .optional()
